import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'helpers/verify';
import { LocalizableMessage, LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';

import { Selector } from 'components/Selector/Selector';
import { MultiSelectCountLabel } from '../../filters/filters.messages';
import { MultiSelectFilterOptionsContainer } from '../../filters/MultiSelectFilterOptionsContainer';

export class MultiSelectFilter extends Component {
  handleOnClear = () => {
    const { onClear, filterName, onSetIsEditing } = this.props;

    onClear(filterName);
    onSetIsEditing(filterName, false);
  };

  handleOnDone = () => {
    const { isOutOfSync, onSyncFilter, filterName, onSetIsEditing } = this.props;

    if (isOutOfSync) {
      onSyncFilter(filterName);
    }
    onSetIsEditing(filterName, false);
  };

  handleToggleExpanded = () => {
    const { filterName, isEditing, onSetIsEditing } = this.props;

    onSetIsEditing(filterName, !isEditing);
  };

  renderSelectionLabel = () => {
    const { selectedName, selectedCount, defaultLabel } = this.props;

    if (selectedName) {
      if (selectedCount > 1) {
        return <MultiSelectCountLabel firstSelectedItem={selectedName} count={selectedCount - 1} />;
      }

      return <LocalizableMessage message={selectedName} />;
    }

    return defaultLabel;
  };

  render() {
    const { isMobile, isSelected, items, selectedItems, filterName, isEditing } = this.props;

    return (
      <Selector isMobile={isMobile} isSelected={isSelected} isOpen={isEditing} onToggle={this.handleToggleExpanded}>
        {({ Controls, DisclosureArrow, Panel, Selection }) =>
          !isEmpty(items) && (
            <div className="unified-filters__filter">
              <Selection>
                {this.renderSelectionLabel()}
                <DisclosureArrow />
              </Selection>
              <Panel onClose={this.handleOnDone}>
                <MultiSelectFilterOptionsContainer filterName={filterName} />
                <Controls
                  disableClearControl={isEmpty(selectedItems)}
                  onClear={this.handleOnClear}
                  onDone={this.handleOnDone}
                />
              </Panel>
            </div>
          )
        }
      </Selector>
    );
  }
}

MultiSelectFilter.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  items: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string,
      }),
    })
  ).isRequired,
  onClear: PropTypes.func.isRequired,
  onSyncFilter: PropTypes.func.isRequired,
  selectedCount: PropTypes.number.isRequired,
  selectedItems: PropTypes.object.isRequired,
  selectedName: LocalizableMessageShape,
  isOutOfSync: PropTypes.bool.isRequired,
  defaultLabel: PropTypes.node.isRequired,
  filterName: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onSetIsEditing: PropTypes.func.isRequired,
};
